import axios from "axios";
import config from "../../../config";

const getLpsListStart = () => {
  return {
    type: "GET_LPS_LIST_START",
  };
};

const getLpsListSuccess = ({ data }) => {
  return {
    type: "GET_LPS_LIST_SUCCESS",
    data,
  };
};

const getLpMetricsFail = () => {
  return {
    type: "GET_LP_METRICS_FAIL",
  };
};

const getLpMetricsStart = () => {
  return {
    type: "GET_LP_METRICS_START",
  };
};

const getLpMetricsSuccess = ({ data }) => {
  return {
    type: "GET_LP_METRICS_SUCCESS",
    data,
  };
};

const getLpsListFail = () => {
  return {
    type: "GET_LPS_LIST_FAIL",
  };
};

export function getLpsList() {
  return (dispatch, getState) => {
    dispatch(getLpsListStart());

    const { login } = getState();

    axios
      .get(`${config.API_URL}/lps/all`, {
        headers: {
          Authorization: `Bearer ${login.token}`,
        },
      })
      .then((resp) => {
        dispatch(getLpsListSuccess({ data: resp.data }));
      })
      .catch((ex) => {
        console.log("Failed to post user", ex);
        dispatch(getLpsListFail());
      });
  };
}

export function getLpMetrics(lpId) {
  return (dispatch, getState) => {
    dispatch(getLpMetricsStart());

    const { login } = getState();

    axios
      .get(`${config.API_URL}/lps/${lpId}/metrics`, {
        headers: {
          Authorization: `Bearer ${login.token}`,
        },
      })
      .then((resp) => {
        console.log(resp, "responsessss");
        dispatch(getLpMetricsSuccess({ data: resp.data }));
      })
      .catch((ex) => {
        console.log("Failed to get Fund metrics", ex);
        dispatch(getLpMetricsFail());
      });
  };
}

// Send reminder
export const sendReminder = (lpId, ccPartner) => {
  return (dispatch, getState) => {
    dispatch({
      type: "SEND_REMINDER_LOADING",
      payload: true,
    });

    const { login } = getState();
    axios
      .post(
        `${config.API_URL}/lps/${lpId}/reminder`,
        {
          ccPartner,
        },
        {
          headers: {
            Authorization: `Bearer ${login.token}`,
          },
        }
      )
      .then((resp) => {
        dispatch({
          type: "SEND_REMINDER",
          payload: resp.data,
        });
      })
      .catch((ex) => {
        console.log("Failed to send reminder", ex);
        dispatch({
          type: "SEND_REMINDER",
          payload: ex,
          error: true,
        });
      });
  };
};

export const resetReminderStatus = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_REMINDER_STATUS", payload: false });
  };
};
